import { NotifyHelper } from "../../../helpers/toast";
import { ePhamViBanActionsObj } from "../../action-types/category/IPhamViBanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const phamViBanActions = {
  ...generateActions(ePhamViBanActionsObj, "PHAM_VI_BAN"),
  ...generateActionForKey(ePhamViBanActionsObj, "PHAM_VI_BAN", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(ePhamViBanActionsObj, "PHAM_VI_BAN", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(ePhamViBanActionsObj, "PHAM_VI_BAN", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(ePhamViBanActionsObj, "PHAM_VI_BAN", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};